<app-conversations-panel [conversations]="conversations" [entityType]="entityType" [objectId]="objectId"
    [initialConversationId]="initialConversationId"></app-conversations-panel>